module.exports = __webpack_public_path__ + "img/5.5d2b6121.png";